import { createLazyResource } from '@magicdoorinc/ui';
import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { RentalApplicationBillingSettingsRepository } from '~/repositories/settings/rentalApplicationBillingSettingsRepository';

export const [RentalApplicationBillingSettingsProvider, useRentalApplicationBillingSettings] = createMagicDoorContext(
  'RentalApplicationBillingSettings',
  () => {
    const repo = new RentalApplicationBillingSettingsRepository();
    const [rentalApplicationBillingSettings, setRentalApplicationBillingSettings] = createSignal<any | undefined>(undefined);
    const [isLoading, setIsLoading] = createSignal<boolean>(false);
    const [error, setError] = createSignal<Error | undefined>(undefined);

    const [paymentSummaryResource, { mutate: mutatePaymentSummary }] = createLazyResource(() => repo.getRentalApplicationPaymentSummary());

    const reloadPaymentSummary = async (): Promise<void> => {
      const result = await repo.getRentalApplicationPaymentSummary();
      mutatePaymentSummary(result);
    };

    const getRentalApplicationBillingSettings = async (): Promise<any | undefined> => {
      setIsLoading(true);
      try {
        const result = await repo.getRentalApplicationBillingSettings();
        setRentalApplicationBillingSettings(result);
        return result;
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setIsLoading(false);
      }
    };

    const updateRentalApplicationBillingSettings = async (payload: any): Promise<any | undefined> => {
      setIsLoading(true);
      try {
        const result = await repo.updateRentalApplicationBillingSettings(payload);
        setRentalApplicationBillingSettings(result);
        return result;
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
        throw err;
      } finally {
        setIsLoading(false);
      }
    };

    return {
      isLoading,
      error,
      rentalApplicationBillingSettings,
      getRentalApplicationBillingSettings,
      updateRentalApplicationBillingSettings,
      paymentSummaryResource,
      reloadPaymentSummary,
    };
  }
);
